export const KeyShortcuts = {
  zoomIn: 'powiekszenie',
  zoomOut: 'pomniejszenie',
  previousView: 'poprzedni_widok',
  nextView: 'następny_widok',
  toggleRuler: 'miarka',
  initialView: 'widok_poczatkowy',
  addWms: 'dodaj_wms',
  openAnalysis1: 'analiza_1',
  openAnalysis2: 'analiza_2',
  select: 'selekcja',
  searchMetadata: 'wyszukaj_metadane',
  maximizeTable: 'zwieksz_tabele',
  minimizeTable: 'zmniejsz_tabele',
  hideLegend: 'schowaj_legende',
  showLegend: 'pokaz_legende',
  reportDiscrepancy: 'zglos_rozbieznosc',
  archiveData: 'dane_archiwalne',
  selectMany: 'selekcja_punktowa_wielu'
};

export const KeysTranslation = [
  { key: ' ', name: 'Spacja' },
  { key: 'Control', name:  'CTRL' },
  { key: 'Shift', name:  'SHIFT' },
  { key: 'ArrowLeft' , name:  'Strzałka w lewo' },
  { key: 'ArrowUp', name:  'Strzałka w górę' },
  { key: 'ArrowRight', name: 'Strzałka w prawo' },
  { key: 'ArrowDown', name:  'Strzałka w dół' },
  { key: 'Alt', name:  'Lewy ALT' }
]

let keyShortcutPermissions = {};
keyShortcutPermissions[KeyShortcuts.openAnalysis1] = 'Analysis_road_line_occupation_costs';
keyShortcutPermissions[KeyShortcuts.openAnalysis2] = 'Analysis_pole_usage_costs';
keyShortcutPermissions[KeyShortcuts.archiveData] = 'Request_for_archive_data';

export const KeyShortcutPermissions = keyShortcutPermissions;
